/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/PollReportQuestionMatrixAxis', 'model/PollReportQuestionMultipleNumericValue', 'model/PollReportQuestionScaleValue'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./PollReportQuestionMatrixAxis'), require('./PollReportQuestionMultipleNumericValue'), require('./PollReportQuestionScaleValue'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.PollReportQuestion = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.PollReportQuestionMatrixAxis, root.ForStractionServiceApi.PollReportQuestionMultipleNumericValue, root.ForStractionServiceApi.PollReportQuestionScaleValue);
  }
}(this, function(ApiClient, PollReportQuestionMatrixAxis, PollReportQuestionMultipleNumericValue, PollReportQuestionScaleValue) {
  'use strict';




  /**
   * The PollReportQuestion model module.
   * @module model/PollReportQuestion
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>PollReportQuestion</code>.
   * @alias module:model/PollReportQuestion
   * @class
   */
  var exports = function() {
    var _this = this;











  };

  /**
   * Constructs a <code>PollReportQuestion</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PollReportQuestion} obj Optional instance to populate.
   * @return {module:model/PollReportQuestion} The populated <code>PollReportQuestion</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Number')) {
        obj['Number'] = ApiClient.convertToType(data['Number'], 'Integer');
      }
      if (data.hasOwnProperty('Title')) {
        obj['Title'] = ApiClient.convertToType(data['Title'], 'String');
      }
      if (data.hasOwnProperty('IsRequired')) {
        obj['IsRequired'] = ApiClient.convertToType(data['IsRequired'], 'Boolean');
      }
      if (data.hasOwnProperty('Type')) {
        obj['Type'] = ApiClient.convertToType(data['Type'], 'Integer');
      }
      if (data.hasOwnProperty('Category')) {
        obj['Category'] = ApiClient.convertToType(data['Category'], 'Integer');
      }
      if (data.hasOwnProperty('Values')) {
        obj['Values'] = ApiClient.convertToType(data['Values'], [PollReportQuestionScaleValue]);
      }
      if (data.hasOwnProperty('MultipleNumericValues')) {
        obj['MultipleNumericValues'] = ApiClient.convertToType(data['MultipleNumericValues'], [PollReportQuestionMultipleNumericValue]);
      }
      if (data.hasOwnProperty('MatrixXAxis')) {
        obj['MatrixXAxis'] = PollReportQuestionMatrixAxis.constructFromObject(data['MatrixXAxis']);
      }
      if (data.hasOwnProperty('MatrixYAxis')) {
        obj['MatrixYAxis'] = PollReportQuestionMatrixAxis.constructFromObject(data['MatrixYAxis']);
      }
      if (data.hasOwnProperty('LastInputValue')) {
        obj['LastInputValue'] = ApiClient.convertToType(data['LastInputValue'], 'Number');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} Number
   * @default 0
   */
  exports.prototype['Number'] = 0;
  /**
   * @member {String} Title
   * @default ''
   */
  exports.prototype['Title'] = '';
  /**
   * @member {Boolean} IsRequired
   * @default false
   */
  exports.prototype['IsRequired'] = false;
  /**
   * @member {Integer} Type
   * @default 0
   */
  exports.prototype['Type'] = 0;
  /**
   * @member {Integer} Category
   * @default 0
   */
  exports.prototype['Category'] = 0;
  /**
   * @member {Array.<module:model/PollReportQuestionScaleValue>} Values
   */
  exports.prototype['Values'] = undefined;
  /**
   * @member {Array.<module:model/PollReportQuestionMultipleNumericValue>} MultipleNumericValues
   */
  exports.prototype['MultipleNumericValues'] = undefined;
  /**
   * @member {module:model/PollReportQuestionMatrixAxis} MatrixXAxis
   */
  exports.prototype['MatrixXAxis'] = undefined;
  /**
   * @member {module:model/PollReportQuestionMatrixAxis} MatrixYAxis
   */
  exports.prototype['MatrixYAxis'] = undefined;
  /**
   * @member {Number} LastInputValue
   */
  exports.prototype['LastInputValue'] = undefined;



  return exports;
}));


